import React from "react";
import styled from "styled-components";
import { space, variant as StyledSystemVariant } from "styled-system";
import { Bar } from "./StyledProgress";
import ProgressBunnyWrapper from "./ProgressBunnyWrapper";
import { ProgressBunny } from "../Svg";
import { ProgressProps, variants, scales, ProgressPropsV2 } from "./types";
import { styleVariants, styleScales } from "./themes";


interface StyledProgressPropsV2 {
    variant: ProgressPropsV2["variant"];
    scale: ProgressPropsV2["scale"];
    $useDark: boolean;
    bgSecondary: string
}

const stepGuard = (step: number) => {
    if (step < 0) {
        return 0;
    }

    if (step > 100) {
        return 100;
    }

    return step;
};

const Progress: React.FC<React.PropsWithChildren<ProgressPropsV2>> = ({
    variant = variants.ROUND,
    scale = scales.MD,
    primaryStep = 0,
    secondaryStep = null,
    showProgressBunny = false,
    useDark = true,
    children,
    bgcolor = '',
    bgSecondary = "#0090FD"
}) => {
    return (
        <StyledProgress $useDark={useDark} variant={variant} scale={scale} bgSecondary={bgSecondary}>
            {children || (
                <>
                    {showProgressBunny && (
                        <ProgressBunnyWrapper style={{ left: `${stepGuard(primaryStep)}%` }}>
                            <ProgressBunny />
                        </ProgressBunnyWrapper>
                    )}
                    <Bar $useDark={useDark} bgcolor={bgcolor} primary style={{ width: `${stepGuard(primaryStep)}%` }} />
                    {secondaryStep ? <Bar $useDark={useDark} style={{ width: `${stepGuard(secondaryStep)}%` }} /> : null}
                </>
            )}
        </StyledProgress>
    );
};

export default Progress;

const StyledProgress = styled.div<StyledProgressPropsV2>`
  position: relative;
  background-color: ${({ bgSecondary }) => bgSecondary};
  box-shadow: ${({ theme }) => theme.shadows.inset};
  overflow: hidden;
  width:100%;
  ${Bar} {
    border-radius: ${({ variant }) => (variant === variants.FLAT ? "0" : "32px")};
  }

  ${StyledSystemVariant({
    variants: styleVariants,
})}
  ${StyledSystemVariant({
    prop: "scale",
    variants: styleScales,
})}
  ${space}
`;